import { Input, OnInit, Component } from '@angular/core';

import { MAX_OPTIONS_TO_DISPLAY } from '../../constants';

@Component({
  selector: 'tablesready-select-options',
  templateUrl: './select-options.component.html',
  styleUrls: ['./select-options.component.scss'],
})
export class SelectOptionsComponent implements OnInit {
  @Input() options: string[];
  @Input() maxSelectOptionsToDisplay = MAX_OPTIONS_TO_DISPLAY;

  optionsToDisplay: string[];
  restOptions: string[] = [];

  ngOnInit(): void {
    this.optionsToDisplay = this.options;

    if (this.options.length > this.maxSelectOptionsToDisplay) {
      this.optionsToDisplay = this.options.slice(0, this.maxSelectOptionsToDisplay);
      this.restOptions = this.options.slice(this.maxSelectOptionsToDisplay, this.options.length);
    }
  }
}
